export const inArray = (state) => Object.values(state.list);
